import { render, staticRenderFns } from "./xunbijiasinform.vue?vue&type=template&id=bc6bebc4&scoped=true"
import script from "./xunbijiasinform.vue?vue&type=script&lang=js"
export * from "./xunbijiasinform.vue?vue&type=script&lang=js"
import style0 from "./xunbijiasinform.vue?vue&type=style&index=0&id=bc6bebc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6bebc4",
  null
  
)

export default component.exports